export default "./dist/stdassets/images/res/slider.png";